import { NavigatorService } from '../services/navigator.service';
var ExternalComponent = /** @class */ (function () {
    function ExternalComponent(navigatorService) {
        this.navigatorService = navigatorService;
    }
    return ExternalComponent;
}());
export { ExternalComponent };
